<template>
  <!--  -->
  <div class="pt-4 px-3 p-3">
    <!--  -->
    <div id="config" class="flex flex-col border p-4 rounded-lg bg-white div-filters">
      <!--  -->
      <div v-if="name != 'userHistories'" class="flex flex-row">
        <!--  -->
        <div class="flex w-full">
          <!--  -->
          <input :placeholder="$t(config.filters.elements.search.options.hint)" v-model="searchText" @keyup.enter="trigger" type="search" autofill="off" class="border-t text-gray-700 text-xs border-b border-l rounded-l-md w-full focus:outline-none py-1 px-4" />
          <!--  -->
          <button @click="search" ref="sendReply" class="bg-white rounded-r-md text-primary-500 border-t border-r border-b hover:opacity-75 px-3 focus:outline-none">
            <!--  -->
            <i class="py-1 material-icons">search</i>
            <!--  -->
          </button>
          <!--  -->
        </div>
        <!--  -->
        
        <!--  -->
        <div class="">
          <!--  -->
          <button @click="showMore = !showMore" class="text-white hover:bg-gray-400 rounded-full bg-primary-600 flex items-center focus:outline-none p-2 ml-2" >
            <!--  -->
            <i v-if="showMore" class="material-icons">keyboard_arrow_up</i>
            <!--  -->
            <i v-else class="material-icons">keyboard_arrow_down</i>
            <!--  -->
          </button>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
      
      <!--  -->
      <div class="flex flex-col" v-if="name == 'userHistories' ? !showMore : showMore">
        <!--  -->
        <div class="w-11/12 flex items-center flex-col md:flex-row justify-center flex-wrap gap-4 mt-4 mx-auto">
          <!--  -->
          <div class="w-full md:w-1/3 lg:w-1/6 mt-4" v-for="(item, index) in config.filters.elements.champs" :key="index" v-show="(isShown(item) && item.key != 'product' && item.key != 'totalPrice' && item.key != 'affiliate_stores' && item.key != 'api_status') || (isShown(item) && item.key == 'product' && filter['seller']) || (isShown(item) && item.key == 'totalPrice' && filter['seller'] && filter['product']) || (isShown(item) && item.key == 'affiliate_stores' && filter['seller'] && filter['seller']._id && filter['seller']._id.toString() === '64d60cfc05f818068c8f4750' && currentUser.type !== 'Seller') || (isShown(item) && item.key == 'api_status' && filter['status'] && currentUser.type !== 'Seller')">
            <!--  -->
            <div class="w-full" v-if="getShow(item.key) && item.key != 'from' && item.key != 'to' && ((item.key == 'warehouses' && item.values.length > 0) || item.key != 'warehouses')">
              <!--  -->
              <div class="border h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="seller" class="bg-white text-gray-700 px-1">
                      <!--  -->
                      {{ $t(item.label) }}
                      <!--  -->
                      <span :class="$colors.required">*</span>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div v-if="item.type == 'select' && getShow(item.key)">
                  <!--  -->
                  <div v-if="item.name">
                    <!--  -->
                    <span v-if="item.key == 'product'">
                      <!--  -->
                      <v-select :disabled="!filter['seller']" @search="getProducts($event)" @input="SelectProduct" :label="item.name" v-model="filter[item.key]" :options="products"></v-select>
                      <!--  -->
                    </span>
                    <!--  -->

                    <!--  -->
                    <span v-else-if="item.key == 'affiliate_stores'">
                      <!--  -->
                      <v-select v-model="filter[item.key]" :options="stores"></v-select>
                      <!--  -->
                    </span>
                    <!--  -->

                    <!--  -->
                    <span v-else-if="item.key == 'api_status'">
                      <!--  -->
                      <v-select v-model="filter[item.key]" :options="apiStatus"></v-select>
                      <!--  -->
                    </span>
                    <!--  -->

                    <!--  -->
                    <span v-else-if="item.key == 'totalPrice'">
                      <!--  -->
                      <v-select v-model="filter[item.key]" :options="prices"></v-select>
                      <!--  -->
                    </span>
                    <!--  -->

                    <!--  -->
                    <span v-else>
                      <!--  -->
                      <v-select :class="config.name === 'orders' && item.key === 'status_pending' && (!checkstatusorder || checkstatusorder != 'Pending') ? 'disabled' : ''" @input="CheckSellerProducts($event, item.key)" @search="searchUsers($event, item.key)" :label="item.name" v-model="filter[item.key]" :options="item.values"></v-select>
                      <!--  -->
                    </span>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div v-else>
                    <!--  -->
                    <v-select @input="Checkstatus(filter[item.key], item.key)" :class=" config.name === 'shippings' && item.key === 'delivered_status' && ((!checkstatusshipping && !filter[item.key]) || (checkstatusshipping != 'delivered' && checkstatusshipping != 'cancelled' && checkstatusshipping != 'refused')) ? 'disabled' : ''" v-model="filter[item.key]" :options="item.values"></v-select>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div v-else-if="item.type == 'number'">
                  <!--  -->
                  <input :min="item.min" :step="item.step" v-model="filter[item.key]" :type="item.type" :name="item.key" :id="item.key" :class="item.class"/>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div v-else>
                  <!--  -->
                  <input v-if="item.type != 'date_range'" v-model="filter[item.key]" :type="item.type" :name="item.key" :id="item.key" :class="item.class"/>
                  <!--  -->
                  <date-picker :disabled=" !date_facture_enable && item.key == 'Facture_date' ? true : false" v-else :placeholder="item.placeholder" @change="DateRange" format="yyyy-MM-DD" class="w-full-imp" v-model="filter[item.key]" range></date-picker>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div v-if="config.filters.hasFilterdate" class="flex flex-row space-x-3 justify-center flex-wrap">
          <!--  -->
          <div v-for="(item, index) in config.filters.elements.champs" :key="index" v-show="isShown(item)">
            <!--  -->
            <div v-if="getShow(item.key) && (item.key == 'from' || item.key == 'to')" class="w-56 py-2">
              <!--  -->
              <div class="border h-10 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="seller" class="bg-white text-gray-700 px-1">
                      <!--  -->
                      {{ item.label }}
                      <!--  -->
                      <span :class="$colors.required">*</span>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <input v-model="filter[item.key]" :type="item.type" :name="item.key" :id="item.key" :class="item.class"/>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="flex flex-row justify-center space-x-2 mt-6">
          <!--  -->
          <button @click="ClearFilters" class="text-sm md:text-base text-primary-500 rounded-md mx-1 border border-gray-100 bg-gray-300 hover:bg-primary-600 w-fit lg:w-1/6 hover:text-white py-2 px-4 focus:outline-none">
            <!--  -->
            {{ $t('reset') }}
            <!--  -->
          </button>
          <!--  -->
          
          <!--  -->
          <button v-if="config.filters.elements.champs.length > 0" @click="filtrer_saerch" class="text-sm md:text-base rounded-md mx-1 border bg-primary-600 text-white w-fit lg:w-1/6 hover:text-primary-500 hover:bg-transparent py-2 px-4 focus:outline-none">
            <!--  -->
            {{ $t('filtrer') }}
            <!--  -->
          </button>
          <!--  -->
        </div>
      <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  props: {
    config: { type: Object },
    currentUser: { type: Object },
    name: { type: String },
  },
  data() {
    return {
      showMore: false,
      searchText: '',
      warhouseCountry: '',
      filter: {},
      idWharhouse: null,
      products: [],
      prices: [],
      stores: [],
      apiStatus:[],
      checkstatusorder: null,
      checkstatusshipping: null,
      checkproduct: null,
      checkseller: null,
      date_facture_enable: false,
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
  },
  watch: {
    warhouseSelected: async function(oldVal, newVal) {
      await this.getwharhouseId();
      await this.getCurrentSellerProducts();
    },
    currentUser(val) {
      if (val.type === 'Seller') this.filter['seller'] = val;
    },
  },
  async mounted() {
    this.warhouseCountry = await this.warhouseSelected;
    if (this.config.name === 'products') {
      this.showMore = true;
    } 

    await this.getwharhouseId();

    this.config.filters.elements.champs.forEach(filter => {
      if (filter.value) {
        this.$set(this.filter, filter.key, filter.value, filter.values);
      }
    });

    await this.getCurrentSellerProducts();
  },
  methods: {
    DateRange(data) {},
    getElementInArray(data, value) {
      if (value) {
        var result = data.filter(function(o) {
          let whar = o.warehouse;
          if (o.warehouse._id) {
            whar = o.warehouse._id;
          } 
          return whar == value.toString();
        });
        return result ? result[0] : null;
      } else {
        return null;
      } 
    },
    getShow(champ) {
      if (champ === 'seller' && this.currentUser.type === 'Seller') {
        return false;
      }
        
      if (champ === 'courier' && this.currentUser.type === 'Seller') {
        const dataWhrahouseSetting = this.getElementInArray(
          this.currentUser.settings,
          this.idWharhouse._id,
        );
        if (dataWhrahouseSetting.fulfillement) {
          return false;
        }
      }

      if (champ === 'zone' && this.currentUser.type === 'Seller') {
        return false;
      } else {
        return true;
      }
    },
    trigger() {
      this.$refs.sendReply.click();
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.config.filters.elements.champs.length; i++) {
        if (this.config.filters.elements.champs[i].type === 'select' && this.config.filters.elements.champs[i].key === model) {
          if (!splice) {
            this.config.filters.elements.champs[i].values = data;
          } else {
            this.config.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.idWharhouse = res;
      });
    },
    async SelectProduct(product) {
      if (product) {
        this.checkproduct = product;
        
        let filters = {
          country: this.idWharhouse.country,
          product: product._id,
          seller: this.filter['seller']._id || this.filter['seller'],
          table: this.name,
        };

        if (this.filter['status']) {
          filters.status = this.filter['status']._id || this.filter['status'];
        } 

        await this.$store.dispatch('wharhouse/searchPricesOrders', filters).then(res => {this.prices = res;});

        if(filters.seller.toString() === '64d60cfc05f818068c8f4750' && this.currentUser.type !== 'Seller'){
          this.stores=[];
          let filtersearchStoresOrders={seller:filters.seller,country:this.idWharhouse.country,table: this.name,product: product._id};
          if (filters.status) filtersearchStoresOrders.status = filters.status;
          
          await this.$store.dispatch('wharhouse/searchStoresOrders', filtersearchStoresOrders).then(res => {
            this.stores = res;
          });
        }
        
      } else {
        this.checkproduct = null;
      } 
    },
    async getCurrentSellerProducts() {
      this.products = [];
      if (this.currentUser.type == 'Seller') {
        const filters = {
          seller: this.currentUser._id,
          'details.warehouse': this.idWharhouse._id,
          limit: 10,
        };
        const res = await this.$server.search('products', filters);
        if (res.content.results) {
          this.products = res.content.results;
        } else this.products = [];
      }
    },
    async Checkstatus(status, key) {
      if (this.name == 'shippings' && status && key && key == 'status') {
        this.checkstatusshipping = status;
        if (status === 'delivered') {
          this.setDataSelect( 'delivered_status', ['pending', 'paid', 'processed'], null);
        }

        if (status === 'delivered' && this.currentUser.type == 'Seller') {
          this.setDataSelect( 'delivered_status', ['pending', 'processed'], null);
        }

        if (status === 'refused' || status === 'cancelled') {
          this.setDataSelect( 'delivered_status', ['pending', 'return', 'processed'], null);
        }

        this.apiStatus=[];

        await this.$store.dispatch('wharhouse/searchApiStatus', {country:this.idWharhouse.country,table: this.name,status:status}).then(res => {
          this.apiStatus = res;
        });
      }

      if (this.name == 'shippings' && status && key && key == 'delivered_status') {
        if (status == 'paid' || status == 'processed') {
          this.date_facture_enable = true;
        } else {
          this.date_facture_enable = false;
        } 
      }
    },
    async CheckSellerProducts(seller, name) {
      if (name == 'seller' && !seller) {
        this.filter['seller'] = null;
        this.filter['product'] = null;
      }

      if (this.name == 'orders' && seller && seller.name && seller.color) {
        this.checkstatusorder = seller.name;
      }

      if ((this.name == 'shippings' || this.name == 'orders' || this.name == 'payments') && seller && seller.role) {
        this.products = [];
        this.checkseller = seller._id;

        const filters = {
          seller: seller._id,
          'details.warehouse': this.idWharhouse._id,
          limit: 10,
        };

        if(this.name !== 'payments'){
            const res = await this.$server.search('products', filters);
            if (res && res.content.results) {
              this.products = res.content.results;
            } else {
              this.products = [];
            } 
        }
        
        if(seller._id.toString() === '64d60cfc05f818068c8f4750' && this.currentUser.type !== 'Seller'){
          this.stores=[];

          let filtersearchStoresOrders={seller:seller._id,country:this.idWharhouse.country,table: this.name};
          if (this.filter['status']) filtersearchStoresOrders.status = this.filter['status']._id || this.filter['status'];

          await this.$store.dispatch('wharhouse/searchStoresOrders', filtersearchStoresOrders).then(res => {
            this.stores = res.filter(item => item);
          });
        }
      }
    },
    getProducts: _.debounce(async function (name) {
      const filterParams = this.$f.QueryStringToobject();
      const filter = { seller: this.sellerSelected, warhouse: this.idWharhouse._id, search: name, notPopulate: true };
      if (filterParams.seller) filter.seller = filterParams.seller;
      await this.$store.dispatch('wharhouse/searchProducts', filter).then((res) => {
        this.products = res;
      })
    }, 500),
    reset: function(val) {
      this.$emit('reset', val);
    },
    filtrer: function(val) {
      this.$emit('filtrer', val);
    },
    search: function() {
      this.$emit('search', this.searchText);
    },
    searchUsers: async function(value, event) {
      if(event === 'seller') this.$emit('searchSellers', value, event);
      if(event === 'courier') this.$emit('searchCouriers', value, 'Courier');
      if(event === 'teleconsultant') this.$emit('searchCouriers', value, 'TeleConsultant');
    },
    isShown(item) {
      let shown = !item.show || (item.show && this.filter[item.show.key] == item.show.equal);
      if (!shown) this.$set(this.filter, item.key, null);
      return shown;
    },
    async filtrer_saerch() {
      this.filtrer(this.filter);
    },
    async ClearFilters() {
      this.reset(this.filter);
      this.filter = {};
    },
  },
};
</script>
